import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "name",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "description",
    type: "text",
    sortable: true,
    searchable: true,
  },
  {
    name: "annual_allowed",
    type: "number",
    sortable: true,
    searchable: true,
  },
];

export default function List() {
  return <ResourceListPage url="leave-types" columns={columns} />;
}
